const emptyAvatarSVG = `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="215px" height="215px" viewBox="0 0 215 215" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
    <title>Group</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <circle id="path-1" cx="100" cy="100" r="100"></circle>
        <circle id="path-3" cx="100" cy="100" r="100"></circle>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group">
            <g id="emtpy_avatar" transform="translate(8.000000, 7.000000)">
                <g id="Oval-3" fill="#E7E7E7" fill-rule="nonzero">
                    <circle id="path-1" cx="100" cy="100" r="100"></circle>
                </g>
                <g id="Oval-Clipped">
                    <mask id="mask-2" fill="white">
                        <use xlink:href="#path-1"></use>
                    </mask>
                    <g id="path-1"></g>
                    <circle id="Oval" fill="#818387" fill-rule="nonzero" mask="url(#mask-2)" cx="100" cy="79" r="31"></circle>
                </g>
                <g id="Oval-2-Clipped">
                    <mask id="mask-4" fill="white">
                        <use xlink:href="#path-3"></use>
                    </mask>
                    <g id="path-1"></g>
                    <ellipse id="Oval-2" fill="#818387" fill-rule="nonzero" mask="url(#mask-4)" cx="102.5" cy="187.5" rx="53.5" ry="78.5"></ellipse>
                </g>
            </g>
            <circle id="Oval-2" stroke="#250E47" stroke-width="13" fill-rule="nonzero" cx="107.5" cy="107.5" r="100"></circle>
        </g>
    </g>
</svg>
`;

export default emptyAvatarSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/emptyAvatarSVG.js